import UpComingCollections from "./UpComingCollections";
export default UpComingCollections;
